const Config = {
  apiUrl: (window as any).API_URI,
};

export default Config;
